export default "__VITE_ASSET__CLFlHgon__"